<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="detail-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="gif-view">
                        <img src="https://web-resource.17m3.com/m3guo/202207/version/skin/1-2.gif" v-if="active == 0 && skin_switch == true">
                        <img :src="skin_data[active].img" v-else>
                    </div>
                    <div class="detail-text">
                        <vuescroll :ops="ops">
                            <h6>{{ skin_data[active].skill }}</h6>
                            <div class="text" v-html="skin_data[active].text_update" v-if="active == 0 && skin_switch == true"></div>
                            <div class="text" v-html="skin_data[active].text" v-else></div>
                        </vuescroll>
                    </div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import vuescroll from 'vuescroll';

export default {
    components: {
        vuescroll,
    },      
    data : function () {
        return {
            ops: {
                rail: {
                    opacity: 0.6,
                    background : '#fff',
                    size: '6px',
                    gutterOfSide : '0px',
                },
                bar: {
                    background: '#4c4a49',
                    keepShow : true,
                    size: '6px',
                }
            },             
            visible : false,
            active : 0,
            skin_switch : false,
            skin_data : [
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/1.gif',
                    skill : 'W技能—真*剑来',
                    text : '战场/关卡中施法距离提升20%/50%</br>\
外部装备为8件物理装备时，获得以下效果</br>\
使用剑来后在5秒内获得衍生技能：剑气</br>\
剑气：对一条直线上的敌方单位造成【攻击力*0.5】的物理伤害，如果施法方向为仙剑所在位置，则会变更为自身向仙剑方向位移，对途中敌方单位造成伤害，如果剑气命中任意敌方单位，则自身获得25%最大生命值的护盾，持续1.5秒</br>\
关卡中，剑气造成【攻击力*15】的物理伤害，剑气生成的护盾生命值为50%最大生命值</br>\
在长生殿*神迹中拥有于吉*隐世剑仙时会给予自身和队友一层剑仙祝福，每层剑仙祝福提升英雄10%全伤害加成（最多可获得50%全伤害加成），当剑仙祝福叠加至5层时，额外获得25%减伤效果',
                    text_update : '战场/关卡中施法距离提升30%/50%</br>\
外部装备为8件物理装备时，获得以下效果</br>\
使用剑来后在5秒内获得衍生技能：剑气</br>\
剑气：对一条直线上的敌方单位造成【攻击力*0.75】的物理伤害，如果施法方向为仙剑所在位置，则会变更为自身向仙剑方向位移，对途中敌方单位造成伤害，如果剑气命中任意敌方单位，则自身获得37.5%最大生命值的护盾，持续1.5秒</br>\
关卡中，剑气造成【攻击力*15】的物理伤害，剑气生成的护盾生命值为50%最大生命值</br>\
在长生殿*神迹中拥有于吉*绝代剑仙时会给予自身和队友一层剑仙祝福，每层剑仙祝福提升英雄10%全伤害加成（最多可获得50%全伤害加成），当剑仙祝福叠加至5层时，额外获得25%减伤效果',
                },
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/2.gif',
                    skill : 'E技能—剑道七章*剑禁',
                    text : '外部装备为8件法术装备时，获得以下效果</br>\
被剑道七章*剑禁命中的敌方单位会在3秒内额外受到来自大招剑舞10%的伤害</br>\
释放剑道七章*剑禁后，延迟1秒召唤万剑诀，对剑禁范围内的敌方单位造成100点法术伤害</br>\
关卡中，万剑诀伤害范围提升至剑禁范围的150%，万剑诀伤害提升至1500点法术伤害',
                },
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/3.gif',
                    skill : 'E技能—雷之能量',
                    text : '外部装备为8件物理装备时，获得以下效果</br>\
雷之能量持续期间提升自身15%所有攻击力</br>\
释放雷之能量后会立即获得【25%最大生命值】的护盾，持续1.5秒。同时会在身边生成3个雷电法球，在雷之能量持续时间内会跟随梦马超不停旋转，雷球碰到敌方单位后会对200范围内的敌方单位造成【攻击力*0.5】物理伤害，同时获得【15%最大生命值】护盾(可叠加)，持续1.5秒</br>\
关卡中，每颗雷球造成【攻击力*10】物理伤害，且雷球爆炸伤害范围提升至450',
                },
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/4.gif',
                    skill : 'F技能—骑射无双',
                    text : '外部装备为8件物理装备时，获得以下效果</br>\
大招持续期间增加自身15%所有攻击力</br>\
大招骑射期间获得衍生技能：骑射冲锋</br>\
骑射冲锋：向指定方向位移一段距离，位移期间处于无敌状态，位移后获得一个60%自身缺失生命值的护盾，持续1.5秒，护盾生命值至少为25%最大生命值</br>\
骑射冲锋每12秒可以使用一次(不受减冷却影响)',
                },
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/5.gif',
                    skill : 'W技能—虎头金枪',
                    text : '外部装备为8件物理装备时，获得以下效果</br>\
虎头金枪造成的伤害提升50%，释放【虎头金枪】后的下次攻击必定触发【百鸟朝凤】。【虎头金枪】使用6秒后会产生爆炸，对虎头金枪光环范围内的单位造成【攻击力*0.75】的物理伤害，若爆炸时张绣位于爆炸范围之内，则其获得【50%最大生命值】的护盾，护盾持续2秒</br>\
关卡中，爆炸造成【攻击力*25】的伤害并且释放【枪锋破敌】技能重置虎头金枪位置后会直接引爆虎头金枪，爆炸范围提升至600</br>\
【额外加成】普通攻击和所有技能对加强护甲单位造成的伤害提升30%',
                },
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/6.gif',
                    skill : 'W技能—落雁曲',
                    text : '外部装备为8件法术装备时，获得以下效果</br>\
战场/关卡中落雁曲伤害提升25%/100%</br>\
每释放3次落雁曲，下次落雁曲命中敌方任意敌方单位后，治疗自身30%已损失生命值</br>\
关卡中，落雁曲会额外释放2道(不造成重复伤害，额外的落雁曲不产生扩散)',
                },
                {
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/skin/7.gif',
                    skill : 'W技能—雷爆术',
                    text : '外部装备为8件法术装备时，获得以下效果</br>\
战场/关卡中作用范围提升25%/100%</br>\
使用雷爆术后在5秒内获得衍生技能：雷鸣</br>\
雷鸣：延迟一段时间在目标点召唤雷鸣(延迟期间可以获得目标区域视野)，雷鸣释放点距离自身越远时召唤雷鸣延迟越久，雷鸣对区域内的单位造成200点法术伤害，命中任意敌方单位后治疗自身30%已损失生命值</br>\
关卡中，雷爆术会将周围敌方单位持续牵引至中心，雷鸣的伤害提升至3000点法术伤害',
                },
                {
                    img : '',
                    skill : '',
                    text : '',
                },                                                                 
            ],
        }
    },
    created (){
        //this.render();
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render (){
            //TODO
        },
    }    
}
</script>

<style scoped>
.detail-modal{
    width: 554px;
    height: 703px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/bg-modal-detail.png);
}

.gif-view{
    width: 498px;
    height: 336px;
    margin: -5px auto 0;
    background-image: url(~@/assets/images/pc/gif-view-d.png);
}

.u-btn.close{
    top: -24px;
    right: -22px;
    width: 32px;
    height: 34px;
    background-image: url(~@/assets/images/pc/vote/btn-close.png);
}

.detail-text{
    height: 277px;
    font-size: 16px;
    margin:  20px 30px 0;
    color: #f2edd9;
}

.detail-text .text{
    padding-right: 20px;
}

.detail-text h6{
    margin-bottom: 20px;
}

@media only screen and (max-width: 1200px){
    .detail-text{
        font-size: 24px;
    }

    .detail-text h6{
        font-size: 24px;
    }

    .detail-modal{
        width: 594px;
        height: 846px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/m/bg-modal-detail.png);
    }

    .detail-text{
        height: 400px;
        padding: 0 20px;
    }    
}
</style>


// WEBPACK FOOTER //
// src/components/SkinDetail/skindetail.vue